<template>
  <div style="height: 100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.48">
      <template #main>
        <TableMain name="one table" ref="QTHRTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query" :table_height_adjust="-6"
          :show_toolbar_button="[0, 0, 0, 0, 1]" :hb_table_class="'hb_table_qthrouteable_class1'"
          :only_text="$t('common.show_all')" @only_methods="only_main_methods" @tool_invoke="tool_invoke"
          @current_changed="current_changed" tableref="efb413de87ac4568aa7fb0a6c60a4e5e">
          <template #query>
            <el-date-picker class="ml-1" size="small" style="width: 220px" v-model="date_range" type="daterange"
              align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptions()">
            </el-date-picker>
            <el-input class="ml-1" placeholder="报价申请编号" clearable size="small" style="width: 180px"
              v-model="QuotationTaskNum"></el-input>
            <el-input placeholder="客户名称" class="ml-1" clearable size="small" style="width: 180px"
              v-model="CustName"></el-input>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="QTHRTable2" :fields="detail_fields" :show_query_container="false" :title="table_title.title2"
          :date_picker_label="date_picker_label" :table_height_adjust="10" :show_pagination="true" :show_filter="false"
          :show_toolbar="false" :pager_count="5" :isBusy="isBusy2" :loading_width="45"
          @current_changed="current_changed_detail" tableref="f4a44ee9292347a3baaf4d653159b20f">
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="QTHRTable3" :fields="detail_route_fields" :show_query_container="false"
          :title="table_title.title3" :show_toolbar="false" :date_picker_label="date_picker_label"
          :table_height_adjust="2" :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy3"
          :show_toolbar_button="[0, 0, 0, 0, 0]" tableref="e16abebc21304744a89722b2f7bd1e7c">
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="Detail_SaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
            <QueryButton :type="'primary'" :iconClass="'iconfont icon-upload'" :size="'mini'" @on_query="Detail_Submit"
              :label="$t('common.commit')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>

  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController"
import * as QuotationTaskHandleController from "../../controllers/sd/QuotationTaskHandleController"
import * as RouteVersionController from "../../controllers/sd/RouteVersionController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import QueryButton from "../components/base/QueryButton"
import SplitContainer3 from "../components/container/SplitContainer3"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    SplitContainer3,
    TableMain,
    QueryButton
  },
  data() {
    return {
      date_picker_label: "",
      date_range: [this.$date.addMonths(new Date(), -3), new Date()],
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "quote_apply",
        title2: "quote_apply_detail",
        title3: "quote_apply_handle_route",
      },
      fields: _.cloneDeep(QuotationTaskController.fields.default),
      detail_fields: QuotationTaskHandleController.fields.detail_route,
      detail_route_fields: QuotationTaskHandleController.fields.detail_route_handle,
      qt_modal_title: "",
      QuotationTaskNum: "",//报价申请编号
      CustName: "",//客户名称
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      isAll: false,
      all_role_users: [],
    }
  },
  async created() {
    this.fields = _.filter(this.fields, (t) => {
      return t.key != "fcCheckSQOApproved" && t.key != "SQOApprover" && t.key != "is_send_email" && t.key != "quotationType" && t.key !== "fcCheckSQOHasClosed"
    })
    let _field = _.find(this.fields, {
      key: "id",
    })
    delete _field["type"]
    await this.getAllRoleUsers()
  },
  mounted() { },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 报价申请相关操作
    async on_query(set_data) {
      this.isBusy = true
      set_data([])
      let hasDate = true
      let p = { is_deleted: { "=": 0 } }
      if (this.QuotationTaskNum != "") {
        p.QuotationTaskNum = { like: "%" + this.QuotationTaskNum + "%" }
        hasDate = false
      }
      if (this.CustName != "") {
        p.CustName = { like: "%" + this.CustName + "%" }
        hasDate = false
      }
      if (!_.isNull(this.date_range) && hasDate) {
        let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        p["create_at"] = { ">=": this.$date.format(this.date_range[0], "yyyy-MM-dd"), "<": _toDate }
      }
      let _result = await QuotationTaskController.methods.getData(p, "route")
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_result[0], (t) => {
          if (t.fcCheckSQOApproved && !t.fcCheckSQOIsAllClosed && !t.fcCheckQuoteDetailIsAllOutsourcing) return t
        })
        _.each(dt, (t) => {
          t._error = !t.fcCheckQuoteConfirmIsOk
        })
        if (!this.isAll)
          dt = _.filter(dt, { fcCheckQuoteConfirmIsOk: false })

        set_data(_.orderBy(dt, ["id"], ["desc"]))
      }
      this.isBusy = false
    },

    ///打印导出
    tool_invoke(data, cb) {
      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },

    async current_changed(old, current) {
      this.$refs.QTHRTable2.SetData([])
      if (current) {
        await this.Detail_Query(current.id)
      }
    },
    //#endregion

    //#region 报价明细相关
    ///查询报价明细
    async Detail_Query(QTId) {
      this.isBusy2 = true
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskId = { "=": QTId }
      p.IsHomemade = { "<>": 2 }
      let _result = await QuotationTaskController.methods.getDetailData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_result[0], (t) => {
          t.IsHomemade = t.IsHomemade ? 1 : 0
          t.Manufacturer = t.Manufacturer.split(",")
          return t
        })
        this.$refs.QTHRTable2.SetData(_.orderBy(dt, ["LineNum"], ["asc"]))
      }
      this.isBusy2 = false
    },

    ///明细行点击事件
    async current_changed_detail(old, current) {
      this.$refs.QTHRTable3.SetData([])
      if (current && current.ItemId == "") {
        this.msgToasts("请完善物料档案！", "info")
        return
      }
      this.isBusy3 = true
      if (current && current.Manufacturer) {
        let dt = []
        for (var i in current.Manufacturer) {
          let dm = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { DataArea: current.Manufacturer[i] })
          if (dm && dm.VenderAccountNum) {
            let m = {
              id: current.id,
              dataAreaId: current.Manufacturer[i],
              AccountNum: dm.VenderAccountNum,
              AccountName: dm.CompanyName
            }
            if (current.ItemId != "") {
              let _result = await RouteVersionController.methods.getData({ dataAreaId: m.dataAreaId, ItemId: current.ItemId, Active: true })
              if (!_.isNull(_result) && _result && _result.length > 0 && _result[0].length > 0 && _result[0][0]) {
                m.activeRouteID = _result[0][0].RouteId
                m.RouteVersionName = _result[0][0].Name
              }
            }

            if (current.RouteID && current.RouteID != "") {
              let routeId_dt = JSON.parse(current.RouteID)
              let mt = _.find(routeId_dt, { dataAreaId: current.Manufacturer[i] })
              if (mt && mt.RouteID && mt.RouteID != "") {
                m.RouteID = mt.RouteID
                m.RouteVersionName = mt.RouteVersionName
              }
            }
            dt.push(m)
          }
        }
        this.$refs.QTHRTable3.SetData(dt)
      }
      this.isBusy3 = false
    },

    ///保存明细
    async Detail_SaveData(cb) {
      //数据验证
      let msg = "", notEQList = [], lm = {}, p = { add: [], edit: [] }
      let detail_data = this.$refs.QTHRTable3.my_data
      if (detail_data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(null)
        return
      }

      _.each(detail_data, (t) => {
        if (t.RouteID && t.RouteID != "" && t.RouteID != t.activeRouteID) {
          notEQList.push(t.AccountNum)
        }
        else if (!t.RouteID || t.RouteID == "") t.RouteID = t.activeRouteID
        lm["id"] = t.id
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      else if (notEQList.length > 0) {
        let is_ok = await this.msgModal(_.join(notEQList, "，") + "供应商工艺已保存版本和当前有效版本不同，是否更新至有效版本？")
        if (is_ok) {
          for (var i in notEQList) {
            let t = _.find(_.cloneDeep(detail_data), { AccountNum: notEQList[i] })
            t.RouteID = t.activeRouteID
          }
        }
      }
      lm["RouteID"] = JSON.stringify(_.map(detail_data, (t) => {
        return {
          AccountNum: t.AccountNum,
          AccountName: t.AccountName,
          RouteID: t.RouteID,
          RouteVersionName: t.RouteVersionName,
          dataAreaId: t.dataAreaId,
        }
      }))
      p.edit.push(lm)
      let rt = await QuotationTaskController.methods.saveDetailData(p)
      if (rt) {
        console.log(detail_data, this.$refs.QTHRTable3.my_data)
        let lineCurrent = this.$refs.QTHRTable2.GetCurrentItem()
        lineCurrent.RouteID = lm.RouteID
        _.each(this.$refs.QTHRTable3.my_data, (t) => {
          t.RouteID = t.activeRouteID
        })
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    async Detail_Submit(cb) {
      //数据验证
      let msg = "", notEQList = [], lm = {}, p = { add: [], edit: [] }
      let detail_data = this.$refs.QTHRTable3.my_data
      if (detail_data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(null)
        return
      }

      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        if (msg == "" && (m.RouteID == "" || !m.RouteID)) {
          msg = "工艺编号不能为空！"
        }
        if (m.RouteID && m.RouteID != "" && m.RouteID != m.activeRouteID) {
          notEQList.push(m.AccountNum)
        }
        lm["id"] = m.id
      })

      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      else if (notEQList.length > 0) {
        let is_ok = await this.msgModal(_.join(notEQList, "，") + "供应商工艺已保存版本和当前有效版本不同，是否更新至有效版本？")
        if (is_ok) {
          for (var i in notEQList) {
            let t = _.find(detail_data, { AccountNum: notEQList[i] })
            t.RouteID = t.activeRouteID
          }
        }
      }
      lm["RouteID"] = JSON.stringify(_.map(detail_data, (t) => {
        return {
          AccountNum: t.AccountNum,
          AccountName: t.AccountName,
          RouteID: t.RouteID,
          RouteVersionName: t.RouteVersionName,
          dataAreaId: t.dataAreaId,
        }
      }))
      lm["RouteConfirmState"] = true
      p.edit.push(lm)
      let rt = await QuotationTaskController.methods.saveDetailData(p)
      if (rt) {
        let lineCurrent = this.$refs.QTHRTable2.GetCurrentItem()
        lineCurrent.RouteID = lm.RouteID
        lineCurrent.RouteConfirmState = true
        ///当bom和工艺都完成后发邮件
        if (lineCurrent.BomConfirmState && lineCurrent.RouteConfirmState)
          await this.SendEmail(lineCurrent)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    only_main_methods(only_value) {
      this.isAll = only_value
      this.on_query(this.$refs.QTHRTable1.SetData)
    },
    ///发送报价申请处理邮件
    async SendEmail(data) {
      let p = { QuotationTaskNum: data.QuotationTaskNum, DetailId: data.id }
      await commonController.handleEmailNotify(p, "bom_and_route", this, this.all_role_users, "email_get_quote_data")
    },
    //#endregion
  },
}
</script>
<style>
.hb_table_qthrouteable_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}
</style>
